// const port = 58629;
// const port = 55532;
const port = 8080;
// const port = 33127;
export const API_URL = `${window.location.protocol}//${
  process.env.NODE_ENV === 'development'
    ? `${window.location.hostname}:${port}`
    : window.location.hostname
}/index.cfm/api/v1/`;
